import axios from "axios";
import { setup } from "goober";
import { prefix } from "goober/prefixer";
import { h } from "preact";
import React from "react";
import { hydrate, render } from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { SWRConfig } from "swr";
import App from "./App";
import DokumentasiUIProvider from "./components/DokumentasiUI/Provider";
import "./index.scss";
import TheAnyTrackPixel from "./libs/analytics/TheAnyTrackPixel";
import TheGA from "./libs/analytics/TheGA";
import TheGTM from "./libs/analytics/TheGTM";
import Loading from "./pages/Loading";
import { persistor, store } from "./redux";

const rootElement = document.getElementById("root");

setup(h, prefix);

const fetcher = (url: string) => axios.get(url).then((res) => res.data);

const AppWrapper = (
  <React.StrictMode>
    <TheGA />
    <TheGTM />
    {/* <TheFBPixel />
    <TheTiktokPixel /> */}
    <TheAnyTrackPixel />
    <SWRConfig
      value={{
        fetcher,
        onError: (err) => {
          console.error(err);
        },
      }}
    >
      <Provider store={store}>
        <DokumentasiUIProvider>
          <PersistGate persistor={persistor} loading={<Loading />}>
            <App />
          </PersistGate>
        </DokumentasiUIProvider>
      </Provider>
    </SWRConfig>
  </React.StrictMode>
);

if (rootElement?.hasChildNodes()) {
  hydrate(AppWrapper, rootElement);
} else {
  render(AppWrapper, rootElement);
}
